import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, requiredActionUrl }) => {
    const token = localStorage.getItem('token');
    const userPermissions = JSON.parse(localStorage.getItem('userMENUS')) || []; // default to empty array if null
    // Check if the user has access to the required action URL
    const hasAccess = userPermissions.some(menu => 
        menu.submenus.some(submenu => submenu.actionUrl === requiredActionUrl)
    );

    return token && hasAccess ? children : <Navigate to="/welcome" />;
};
export default PrivateRoute;